import React from 'react';
import { useParams } from 'react-router-dom';

import { OfferUpdatePageContainer } from '@occc-app/offerHelpers/components/OfferUpdatePageContainer';
import { OfferType } from '@occc-app/offerValidationService/types';
import { useChainId } from '@occc-app/Chain/hooks';
import { getUpdatePageLinks, useGetCampaignName } from '@occc-app/routes/CampaignComponents/utils';

import { ChallengeConfigureFormContainer } from '../components/ChallengeConfigureForm/ChallengeConfigureFormContainer';
import { messages } from '../messages';

export const ChallengeUpdatePageContainer: React.FC = () => {
  const { id: campaignId = '', challengeId = '' } = useParams<{
    id: string;
    challengeId: string;
  }>();
  const chainId = useChainId();
  const campaignName = useGetCampaignName(chainId, campaignId);
  const getBreadcrumbLinks = (campaignComponentName: string) =>
    getUpdatePageLinks({
      campaignId,
      campaignComponentId: challengeId,
      campaignName,
      pageTitle: messages.configurePageTitle,
      campaignComponentName,
    });

  return (
    <OfferUpdatePageContainer
      campaignId={campaignId}
      offerId={challengeId}
      getBreadcrumbLinks={getBreadcrumbLinks}
      pageTitle={messages.configurePageTitle}
      subtitle={messages.subtitle}
      offerType={OfferType.Challenge}
      ConfigureFormContainer={ChallengeConfigureFormContainer}
    />
  );
};
